<template>
  <div class="container mx-auto p-5">
    <div class="flex items-center justify-center">
      <div class="w-full lg:w-2/3 mt-10 mb-10">
        <div class="shadow-lg rounded-lg bg-white">
          <div class="p-5">
            <!-- Back Arrow -->
            <div class="mb-5">
              <div
                class="bg-gray-100 rounded-full w-10 h-10 flex items-center justify-center"
              >
                <router-link to="/mshel-mentorship-club">
                  <i class="fa-solid fa-circle-arrow-left text-gray-600"></i>
                </router-link>
              </div>
            </div>
            <!-- Logo -->
            <div class="flex justify-center mb-5">
              <router-link to="/">
                <img
                  src="../assets/images/BM_Blue.svg"
                  alt="MMC Logo"
                  class="h-16"
                />
              </router-link>
            </div>
            <!-- Title -->
            <h3 class="text-center text-3xl font-bold text-gray-800 mb-8">
              Mshel Mentoring Club Registration
            </h3>
            <!-- Form -->
            <form @submit.prevent="submitRegistration" class="space-y-6 mt-5">
              <!-- Full Name and Email -->
              <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
                <div>
                  <label
                    for="Fname"
                    class="block text-sm font-medium text-gray-700"
                    >Full Name</label
                  >
                  <input
                    type="text"
                    id="Fname"
                    placeholder="Enter full name"
                    v-model="registrationForm.full_name"
                    class="mt-1 block w-full p-2 border border-gray-300 rounded-lg"
                  />
                </div>
                <div>
                  <label
                    for="email"
                    class="block text-sm font-medium text-gray-700"
                    >Email Address</label
                  >
                  <input
                    type="email"
                    id="email"
                    placeholder="Enter email address"
                    v-model="registrationForm.email"
                    class="mt-1 block w-full p-2 border border-gray-300 rounded-lg"
                  />
                </div>
              </div>
              <!-- Phone Number and Gender -->
              <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
                <div>
                  <label
                    for="phoneNumber"
                    class="block text-sm font-medium text-gray-700"
                    >Phone Number</label
                  >
                  <input
                    type="text"
                    id="phoneNumber"
                    placeholder="Enter phone number"
                    v-model="registrationForm.phone_number"
                    class="mt-1 block w-full p-2 border border-gray-300 rounded-lg"
                  />
                </div>
                <div>
                  <label
                    for="gender"
                    class="block text-sm font-medium text-gray-700"
                    >Gender</label
                  >
                  <select
                    id="gender"
                    v-model="registrationForm.gender"
                    class="mt-1 block w-full p-2 border border-gray-300 rounded-lg"
                  >
                    <option disabled selected>Select Gender</option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                  </select>
                </div>
              </div>
              <!-- Remaining Fields -->
              <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
                <div>
                  <label
                    for="occupation"
                    class="block text-sm font-medium text-gray-700"
                    >Occupation</label
                  >
                  <input
                    type="text"
                    id="occupation"
                    placeholder="Enter occupation"
                    v-model="registrationForm.occupation"
                    class="mt-1 block w-full p-2 border border-gray-300 rounded-lg"
                  />
                </div>
                <div>
                  <label
                    for="businessSector"
                    class="block text-sm font-medium text-gray-700"
                    >Business Sector Industry</label
                  >
                  <select
                    id="businessSector"
                    v-model="registrationForm.business_sector_industry"
                    class="mt-1 block w-full p-2 border border-gray-300 rounded-lg"
                  >
                    <option disabled selected>Select Business Sector</option>
                    <option
                      v-for="(sector, index) in businessData"
                      :key="index"
                      :value="sector"
                    >
                      {{ sector }}
                    </option>
                  </select>
                </div>
              </div>
              <!-- Challenges and Address -->
              <div>
                <label
                  for="challenge"
                  class="block text-sm font-medium text-gray-700"
                  >Challenges</label
                >
                <textarea
                  id="challenge"
                  rows="5"
                  placeholder="Enter your challenges"
                  v-model="registrationForm.challenges"
                  class="mt-1 block w-full p-2 border border-gray-300 rounded-lg"
                ></textarea>
              </div>
              <div>
                <label
                  for="residentialAddress"
                  class="block text-sm font-medium text-gray-700"
                  >Residential Address</label
                >
                <textarea
                  id="residentialAddress"
                  rows="5"
                  placeholder="Enter your residential address"
                  v-model="registrationForm.residential_address"
                  class="mt-1 block w-full p-2 border border-gray-300 rounded-lg"
                ></textarea>
              </div>
              <div>
                <label
                  for="stateOfResidence"
                  class="block text-sm font-medium text-gray-700"
                  >State of Residence</label
                >
                <textarea
                  id="stateOfResidence"
                  rows="5"
                  placeholder="Enter your state of residence"
                  v-model="registrationForm.state_of_residence"
                  class="mt-1 block w-full p-2 border border-gray-300 rounded-lg"
                ></textarea>
              </div>
              <!-- Submit Button -->
              <div class="flex justify-center">
                <button
                  type="submit"
                  class="bg-gradient text-white rounded px-4 py-2 transition-transform hover:scale-110 focus:outline-none"
                >
                  Register
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import apiService from "../services/apiService";
import {
  showErrorAlert,
  showLoadingAlert,
  showSuccessAlert,
} from "../services/reusableService";

export default {
  data() {
    return {
      registrationForm: {
        full_name: "",
        email: "",
        phone_number: "",
        gender: "",
        occupation: "",
        business_sector_industry: "",
        challenges: "",
        residential_address: "",
        state_of_residence: "",
        training_type_id: "", // Dynamically assigned in mounted
      },
      businessData: [],
    };
  },
  methods: {
    async fetchBusinessSectors() {
      try {
        const response = await apiService.getBusinessSector();
        this.businessData = response.data.data || [];
      } catch (error) {
        console.error("Failed to fetch business sectors:", error);
      }
    },
    async submitRegistration() {
      try {
        showLoadingAlert("Processing your registration...");

        const formData = new FormData();
        Object.keys(this.registrationForm).forEach((key) => {
          formData.append(key, this.registrationForm[key]);
        });

        const response = await apiService.createRegistration(formData);

        // Check for success based on `status`
        if (response && response.data && response.data.status === true) {
          console.log("Registration successful:", response.data);
          showSuccessAlert("Registration submitted successfully!");
          this.resetForm();
        } else {
          console.warn("Response does not indicate success:", response);
          showErrorAlert("Registration was not successful. Please try again.");
        }
      } catch (error) {
        const errorMessage =
          error.response?.data?.message ||
          "Failed to submit registration. Please try again.";
        console.error("Error during registration submission:", error);
        showErrorAlert(errorMessage);
      } finally {
        // Ensure the loading alert is closed
        // Swal.close();
        console.log("Swal closed");
      }
    },
    resetForm() {
      this.registrationForm = {
        full_name: "",
        email: "",
        phone_number: "",
        gender: "",
        occupation: "",
        business_sector_industry: "",
        challenges: "",
        residential_address: "",
        state_of_residence: "",
        training_type_id: this.$route.params.id || "",
      };
    },
  },
  mounted() {
    this.registrationForm.training_type_id = this.$route.params.id || "";
    this.fetchBusinessSectors();
  },
};
</script>

<style scoped>
.text-3xl {
  font-size: 24px !important;
}
</style>
